export default __webpack_public_path__ + "static/media/hht2_ep06_timeline_01.df0ea48a.png";